import React from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Paper,
} from '@mui/material';

export type BulkFlowStep = 'upload-review' | 'review-details';

interface BulkFlowIndicatorProps {
  currentStep: BulkFlowStep;
}

const BulkFlowIndicator: React.FC<BulkFlowIndicatorProps> = ({
  currentStep,
}) => {const steps = [
    {
      key: 'upload-review',
      label: 'Upload & Review',
    },
    {
      key: 'review-details',
      label: 'Job Details & Actions',
    },
  ];

  const activeStep = steps.findIndex(step => step.key === currentStep);  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((step) => (
          <Step key={step.key}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Paper>
  );
};

export default BulkFlowIndicator;
